import { useEffect, useState } from 'react'

export function clampPaneWidth(value, min, max) {
  return Math.min(max, Math.max(min, value))
}

function readStoredWidth(key, { min, max, fallback, missingValue = fallback }) {
  try {
    const raw = window.localStorage.getItem(key)
    const value = Number(raw === null ? missingValue : raw)
    return Number.isFinite(value) ? clampPaneWidth(value, min, max) : fallback
  } catch {
    return fallback
  }
}

export function useStoredPaneWidth(key, options) {
  const [width, setWidth] = useState(() => readStoredWidth(key, options))

  useEffect(() => {
    try { window.localStorage.setItem(key, String(width)) } catch { /* private mode */ }
  }, [key, width])

  return [width, setWidth]
}

export function startPaneResize(event, setWidth, { min, max, measure }) {
  event.currentTarget.setPointerCapture?.(event.pointerId)
  const onMove = (moveEvent) => setWidth(clampPaneWidth(measure(moveEvent), min, max))
  const onUp = () => {
    window.removeEventListener('pointermove', onMove)
    window.removeEventListener('pointerup', onUp)
  }
  window.addEventListener('pointermove', onMove)
  window.addEventListener('pointerup', onUp)
}

export default function PaneResizer({ label, min, max, value, onPointerDown, className = '', tabIndex = 0 }) {
  return (
    <div
      className={'pane-resizer' + (className ? ' ' + className : '')}
      role="separator"
      aria-label={label}
      aria-orientation="vertical"
      aria-valuemin={min}
      aria-valuemax={max}
      aria-valuenow={value}
      tabIndex={tabIndex}
      onPointerDown={onPointerDown}
    />
  )
}
